// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/yxyweb/client/styles/default/menu-new.less
// module id = 3214
// module chunks = 0